declare global {
    interface Window {
        SiteSettings: any;
    }
}

//settings class 
export class SettingsClass {
    siteUrl: string = window.SiteSettings.siteUrl;
    siteName: string = window.SiteSettings.siteName;
    siteNameCaps: string = window.SiteSettings.siteNameCaps;
    socialLinks: any = window.SiteSettings.socialLinks;
    
    siteImageFolder: string = '/assets/' + window.SiteSettings.siteName + '/img/';
    vueReCaptchaSiteKey: string = window.SiteSettings.vueReCaptchaSiteKey;
    hcaptchaSiteKey: string = window.SiteSettings.hcaptchaSiteKey;
    hcaptchaSecret: string = window.SiteSettings.hcaptchaSecret;
    googleTagId: string = window.SiteSettings.googleTagId;
    aboutUs: string = window.SiteSettings.aboutUs;
    showBlog: boolean = window.SiteSettings.showBlog;
    showLists: boolean = window.SiteSettings.showLists;
    showGiftIdeas: boolean = window.SiteSettings.showGiftIdeas;
    blogTitle: string = window.SiteSettings.blogTitle;
    isShabbat: boolean = window.SiteSettings.isShabbat;
    shabbatEnds: string = window.SiteSettings.shabbatEnds;
    contactPhone: string = window.SiteSettings.contactPhone;
    contactEmail: string = window.SiteSettings.contactEmail;
    homepageBanner: string = window.SiteSettings.homepageBanner;
    topBannerAnimationSrc: string = window.SiteSettings.topBannerAnimationSrc;
    facebookPixelId: string = window.SiteSettings.facebookPixelId;
    logoUrl: string = window.SiteSettings.logoUrl;
    logoImageNoBackground: string = window.SiteSettings.logoImageNoBackground;
    logoSquare: string | null = window.SiteSettings.logoSquare;
    jcn_pid: string = window.SiteSettings.jcn_pid;
    jcn_ads_on: boolean = window.SiteSettings.jcn_ads_on;
    medianet_on: boolean = window.SiteSettings.medianet_on;
    purimMode: boolean = window.SiteSettings.purimMode;

    constructor(partial?: Partial<SettingsClass>) {
        Object.assign(this, partial);
    }
}

const settings: SettingsClass = new SettingsClass();
export default settings;